/* **************************************************** Finishing Shedule Document */
export interface FSDocument {
    id: number;
    fs_feature_id: number;
    document_name: string;
    path: string;
    extension: string;
}

export const mapFSDocument = (data: any): FSDocument => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSDocument = {
        id: data.id,
        fs_feature_id: data.fs_feature_id,
        document_name: data.document_name,
        path: data.path,
        extension: data.extension,
    };

    return res;
};

export const mapFSDocuments = (data: any[]): FSDocument[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSDocument);
};
